const C = {
  name: "BrowserFilled",
  dimensions: { width: 40, height: 41 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_27_2021)">
    <path d="M5 4.00293C4.45 4.00293 4 4.45293 4 5.00293C4 5.55293 4.45 6.00293 5 6.00293C5.55 6.00293 6 5.55293 6 5.00293C6 4.45293 5.55 4.00293 5 4.00293Z" />
    <path d="M9 4.00293C8.45 4.00293 8 4.45293 8 5.00293C8 5.55293 8.45 6.00293 9 6.00293C9.55 6.00293 10 5.55293 10 5.00293C10 4.45293 9.55 4.00293 9 4.00293Z" />
    <path d="M13 4.00293C12.45 4.00293 12 4.45293 12 5.00293C12 5.55293 12.45 6.00293 13 6.00293C13.55 6.00293 14 5.55293 14 5.00293C14 4.45293 13.55 4.00293 13 4.00293Z" />
    <path d="M2 7.00293V2.00293H37C37.55 2.00293 38 2.45293 38 3.00293V8.00293H3C2.45 8.00293 2 7.55293 2 7.00293ZM38 23.0029H15C14.45 23.0029 14 22.5529 14 22.0029V10.0029H37C37.55 10.0029 38 10.4529 38 11.0029V23.0029ZM14 37.0029V25.0029H37C37.55 25.0029 38 25.4529 38 26.0029V38.0029H15C14.45 38.0029 14 37.5529 14 37.0029ZM2 10.0029H11C11.55 10.0029 12 10.4529 12 11.0029V38.0029H3C2.45 38.0029 2 37.5529 2 37.0029V10.0029ZM38 0.00292969H2C0.9 0.00292969 0 0.90293 0 2.00293V8.00293V10.0029V38.0029C0 39.1029 0.9 40.0029 2 40.0029H38C39.1 40.0029 40 39.1029 40 38.0029V10.0029V8.00293V2.00293C40 0.90293 39.1 0.00292969 38 0.00292969Z" />
    </g>
    <defs>
    <clipPath id="clip0_27_2021">
    <rect width="40" height="40" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  C as BrowserFilled
};
